export default [
  { id: '1', label: 'candidate.firstname', translationKey: 'html-editor.candidate-first-name' },
  { id: '2', label: 'candidate.lastname', translationKey: 'html-editor.candidate-last-name' },
  { id: '3', label: 'candidate.phonenumber', translationKey: 'html-editor.candidate-phone' },
  { id: '4', label: 'position.name', translationKey: 'html-editor.position-name' },
  { id: '5', label: 'location.name', translationKey: 'html-editor.location-name' },
];
